import { render, staticRenderFns } from "./RegistrationOrganization.vue?vue&type=template&id=488ed2ad&scoped=true"
import script from "./RegistrationOrganization.vue?vue&type=script&lang=js"
export * from "./RegistrationOrganization.vue?vue&type=script&lang=js"
import style0 from "./RegistrationOrganization.vue?vue&type=style&index=0&id=488ed2ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ed2ad",
  null
  
)

export default component.exports